module.exports = __webpack_public_path__ + "img/vol05_character_img03_sp.75bb6b23.png";